import React, { FC } from 'react';
import { Grid, Link, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { Group } from 'api';
import { generateLink } from 'Links';

const styles = (theme: Theme) =>
  createStyles({
    colorBlock: {
      display: 'inline-block',
      height: 11,
      width: 11,
      marginRight: theme.spacing(1),
      borderRadius: '50%',
    },
  });

interface IProps extends WithStyles<typeof styles> {
  group: Group;
}

const TitleCell: FC<IProps> = ({ classes, group }) => (
  <Grid item xs zeroMinWidth>
    <Typography variant="subtitle2" noWrap>
      <div className={classes.colorBlock} style={{ backgroundColor: group.color_map.hex }} />
      <Link component={generateLink(`/group/${group.id}`)}>{group.title}</Link>
    </Typography>
  </Grid>
);

export default withStyles(styles)(TitleCell);
